// extracted by mini-css-extract-plugin
module.exports = {"container":"GenericTypesTab_container__1l5s8"};